export default __webpack_public_path__ + "static/Roobert-Medium-50c7ef769c9b93a65e950c7d6b9f5915.woff";